import React, { ReactElement, useEffect, useRef, useState } from 'react';
import classNames from "classnames";

import styles from './TextContent.module.scss';

interface IProps {
  text: string,
}

const MAX_LINES_FOR_COLLAPSE = 4;
const DEFAULT_LINE_HEIGHT = 20;

export const TextBlock = ({
  text,
}: IProps): ReactElement => {
  const [isToggled, setIsToggled] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight) || DEFAULT_LINE_HEIGHT; 
      const maxHeight = lineHeight * MAX_LINES_FOR_COLLAPSE;
      const needsCollapse = textRef.current.scrollHeight > maxHeight;
      
      setShowButton(needsCollapse);
      setIsToggled(!needsCollapse);
    }
  }, [text]);

  const toggleText = () => {
    setIsToggled(!isToggled);
  };

  return (
    <div className={styles.container}>
      <section
        ref={textRef}
        className={classNames(styles.content, {
          [styles.collapsed]: !isToggled && showButton
        })}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {showButton && (
        <button 
          onClick={toggleText} 
          className={styles.toggleButton}
        >
          {isToggled ? 'Свернуть' : 'Развернуть'}
        </button>
      )}
    </div>
  );
};